var _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBarClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "url(#paint0_linear_1895_98959)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0735 16.3935C15.438 16.7579 16.029 16.7579 16.3935 16.3935C16.758 16.029 16.758 15.438 16.3935 15.0735L13.3201 12.0002L16.3935 8.9268C16.7579 8.56231 16.7579 7.97135 16.3935 7.60686C16.029 7.24237 15.438 7.24237 15.0735 7.60686L12.0002 10.6802L8.9268 7.60686C8.56231 7.24237 7.97136 7.24237 7.60687 7.60686C7.24238 7.97135 7.24238 8.56231 7.60687 8.92679L10.6802 12.0002L7.60686 15.0735C7.24237 15.438 7.24237 16.029 7.60686 16.3935C7.97135 16.7579 8.56231 16.7579 8.92679 16.3935L12.0002 13.3201L15.0735 16.3935Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1895_98959",
    x1: -6.70909,
    y1: -13.3636,
    x2: 18.4909,
    y2: 28.0364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB9A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF5023"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarClose);
export default __webpack_public_path__ + "static/media/bar-close.77c63ab087233a83dd5f46f3d6d88a13.svg";
export { ForwardRef as ReactComponent };